import Axios from 'axios';
import { grochatUrl } from '../config/serviceConfig';

const PostFormDataGrochat = (path, data, token) => {
    return Axios({
        method: 'POST',
        url: grochatUrl + path,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': token
        }
    })
}

export default PostFormDataGrochat;